import { useQuery } from '@apollo/client';
import useScreenSize from './useScreenSize';
import { useBreakpoint } from './useBreakpoint';
import { GetCategoriesResponse } from '@/api/types/categories.types';
import { GET_CATEGORIES } from '@/api/queries/categories.queries';

export function useCategories(isOpen: boolean) {
  const { isLarge } = useScreenSize();
  const { isDesktop } = useBreakpoint();

  const { data: { categories = [] } = {}, loading } =
    useQuery<GetCategoriesResponse>(GET_CATEGORIES, {
      skip: !isOpen,
      variables: { isDesktop: isLarge || isDesktop },
    });
  return {
    categories,
    loading,
  };
}
